import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { Seo } from '../../../components/Seo';

import {
  Screen1,
  Intro,
  Content,
  Days,
  WaitTop,
  WaitBottom,
  Result,
  Final,
  Reg,
  Speaker,
  Advance,
  Footer
} from "../../../components/LandingTemplates/marathon_intellektualnyj_privedi_svoj_mozg_v_tonus";

const TITLE = 'Интеллектуальный марафон: приведи свой мозг в тонус!';
const DESCRIPTION = 'Бесплатный онлайн марафон, на котором вы узнаете, как работать без стресса и держать мозг в тонусе: полезные упражнения, советы и рекомендации от образовательного центра Advance.';
export const Head = () => (
  <>
    <Seo title={TITLE} description={DESCRIPTION}>
      <title>{TITLE}</title>
    </Seo>
  </>
)

const Page = () => {
  return <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ overflowX: "hidden" }}>
      <Screen1 id={'im_11'} />
      <Intro />
      <Content />
      <Days />
      <WaitTop />
      <WaitBottom />
      <Result />
      <Final />
      <Reg widget={<GetCourseWidget hash={'a6e9608cc04b7028f014e8e68662219cd5487ac5'} id={'1097687'} />} />
      <Speaker />
      <Advance />
    </main>

    <Footer />

  </DefaultLayout>
};
export default Page;
